import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sub",
  "use": "icon-sub-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sub\"><defs><style type=\"text/css\"></style></defs><path d=\"M543.6 255.6h-255c-17.4 0-31.5 14.1-31.5 31.5s14.1 31.5 31.5 31.5h255c17.4 0 31.5-14.1 31.5-31.5s-14.1-31.5-31.5-31.5zM418 446.1H288.6c-17.4 0-31.5 14.1-31.5 31.5s14.1 31.5 31.5 31.5H418c17.4 0 31.5-14.1 31.5-31.5s-14.1-31.5-31.5-31.5z\" p-id=\"1247\" fill=\"#c1c9d9\" /><path d=\"M895 193.5H766V129c0-34.8-28.3-63-63-63H129c-34.8 0-63 28.3-63 63v640c0 34.8 28.3 63 63 63h129v64.5c0 34.8 28.3 63 63 63h574c34.8 0 63-28.3 63-63v-640c0-34.7-28.3-63-63-63zM130 768.1V130h572v638.1H130z m764 127.5H322v-63.5h381c34.8 0 63-28.3 63-63V257.5h128v638.1z\" p-id=\"1248\" fill=\"#c1c9d9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sub.svg
// module id = H08+
// module chunks = 100